/**
 * @fileoverview Formatação dos números, datas e durações da página de
 * resultados do fluxo. Valor sem base (taxa sem divisor, data ausente) vira
 * "—": a tela não inventa zero.
 */

export const EMPTY = "—";

export const formatNumber = (value) => Number(value || 0).toLocaleString("pt-BR");

/** 0.9532 → "95,3%"; null (sem base) → "—". */
export const formatPercent = (ratio) =>
  ratio === null || ratio === undefined
    ? EMPTY
    : `${(Number(ratio) * 100).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`;

export const formatCurrency = (value, currency = "BRL") => {
  try {
    return Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: currency || "BRL" });
  } catch {
    return Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }
};

const asDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** Data e hora no horário de quem está vendo: "13/10/2026 14:05". */
export const formatDateTime = (value) => {
  const date = asDate(value);
  return date ? date.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : EMPTY;
};

/** Hora com segundos, para a linha do tempo: "14:05:09". */
export const formatClock = (value) => {
  const date = asDate(value);
  return date ? date.toLocaleTimeString("pt-BR") : EMPTY;
};

// Os dias do painel vêm como "AAAA-MM-DD" (fuso de São Paulo): são mostrados
// como vieram, sem passar por fuso nenhum.
const dayParts = (day) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(day || ""));
  return match ? { year: match[1], month: match[2], date: match[3] } : null;
};

/** "2026-10-13" → "13/10". */
export const formatDayShort = (day) => {
  const parts = dayParts(day);
  return parts ? `${parts.date}/${parts.month}` : EMPTY;
};

/** "2026-10-13" → "13/10/2026". */
export const formatDayLong = (day) => {
  const parts = dayParts(day);
  return parts ? `${parts.date}/${parts.month}/${parts.year}` : EMPTY;
};

/** Duração curta: "40 s", "12 min", "3 h 05 min", "2 d 4 h". */
export const formatDuration = (ms) => {
  const total = Math.max(0, Math.round(Number(ms || 0) / 1000));
  if (total < 60) return `${total} s`;
  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h ${String(minutes % 60).padStart(2, "0")} min`;
  return `${Math.floor(hours / 24)} d ${hours % 24} h`;
};
